import React, { useEffect, useRef } from 'react'

const ToggleButton = ({ items, selectedItemId, onToggle }) => {
  const sliderRef = useRef(null)

  useEffect(() => {
    const index = items.findIndex((i) => i.id === selectedItemId)
    if (sliderRef.current) {
      sliderRef.current.style.left = `calc(${index * 50}% + 5px)`
    }
  }, [selectedItemId, items])

  const handleClick = (item) => {
    if (onToggle) {
      onToggle(item.id)
    }
  }

  return (
    <div className="toggle-with-instruction-wrapper">
      <div className="toggle-instruction">Please select back shape, then seat shape</div>
      <div className="toggle-wrapper">
        <div className="slider" ref={sliderRef}></div>
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            data-testid={item.slug}
            className={`toggle-button ${selectedItemId === item.id ? 'active' : ''}`}
            onClick={() => handleClick(item)}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default ToggleButton
